<script>
import SharedPageHeader from '@/components/cars/edit/SharedPageHeader.vue'
import SentNotifications from '@/components/cars/notifications/SentNotifications.vue'

export default {
  components: {
    'mia-car-edit-shared-page-header': SharedPageHeader,
    'mia-sent-notifications': SentNotifications
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  }
}
</script>

<template>
  <div class="mb-8">
    <mia-car-edit-shared-page-header />

    <div class="space-y-16 mt-16">
      <mia-sent-notifications :car-id="car.id" />
    </div>
  </div>
</template>
